import { render } from "./NewProducts.vue?vue&type=template&id=797dde05"
import script from "./NewProducts.vue?vue&type=script&lang=js"
export * from "./NewProducts.vue?vue&type=script&lang=js"

import "./NewProducts.vue?vue&type=style&index=0&id=797dde05&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__